function handleBirdCartPagePicker() {
  if (document.querySelector(".waio__net--wrapper a[name='netTerm']")) {
    document
      .querySelector("#birdchime-slots-box")
      ?.style.setProperty("display", "none", "important");
  }
}

function handleCustomMessageForB2B() {
  const productPrice = document.querySelector("[data-product-price_ws]");
  const messageElement = document.querySelector(".b2bb-message.hidden");
  const targetElement = document.querySelector(".block__icon__row p");

  if (productPrice && messageElement && targetElement) {
    targetElement.innerText = messageElement.textContent
      .replace(/\s+/g, " ")
      .trim();
  }

  document.querySelector(".product__block.block__icon__row.hidden")?.classList.remove("hidden");
}


(function () {
  let count = 0;

  const interval = setInterval(() => {
    handleBirdCartPagePicker();
    handleCustomMessageForB2B();
    count++;

    if (count >= 10) {
      clearInterval(interval);
    }
  }, 1000);
})();